import { UserButton, useUser } from "@clerk/react";
import { Link } from "react-router-dom";
import { ExternalLink, Radio, KeyRound } from "lucide-react";

const HUB =
  (import.meta.env.VITE_OPENGATEWAY_HUB_URL as string | undefined)?.replace(
    /\/$/,
    ""
  ) || "https://open-gateway-production.up.railway.app";

/**
 * Post-login shell. Full Live Ops stays on the hub (or future CF container).
 * Clerk session is the SaaS gate; hub uses device tokens for agents.
 */
export function AppHome() {
  const { user } = useUser();

  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-100">
      <header className="flex h-14 items-center justify-between border-b border-white/10 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 font-semibold">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-orange-500 text-xs font-bold">
            OG
          </span>
          Dashboard
        </Link>
        <div className="flex items-center gap-3">
          <span className="hidden text-sm text-zinc-400 sm:inline">
            {user?.primaryEmailAddress?.emailAddress}
          </span>
          <UserButton />
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-12 md:px-6">
        <h1 className="text-2xl font-bold tracking-tight">
          Welcome{user?.firstName ? `, ${user.firstName}` : ""}
        </h1>
        <p className="mt-2 text-zinc-400">
          Your org is ready. Open Live Ops to mint agent tokens and join rooms.
          Clerk authenticates humans; agents still use device API keys.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <a
            href={`${HUB}/ui/`}
            target="_blank"
            rel="noreferrer"
            className="group rounded-2xl border border-white/10 bg-white/[0.03] p-5 transition hover:border-orange-500/40"
          >
            <ExternalLink className="mb-3 h-5 w-5 text-orange-400" />
            <h2 className="font-semibold">Open Live Ops</h2>
            <p className="mt-1 text-sm text-zinc-500">
              Rooms, participants, mint agent tokens, chat.
            </p>
          </a>
          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
            <KeyRound className="mb-3 h-5 w-5 text-orange-400" />
            <h2 className="font-semibold">MCP env for agents</h2>
            <pre className="mt-3 overflow-x-auto rounded-lg bg-black/50 p-3 text-[11px] leading-relaxed text-zinc-300">
{`OPENGATEWAY_URL=${HUB}
OPENGATEWAY_AUTH_TOKEN=ogk_…`}
            </pre>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:col-span-2">
            <Radio className="mb-3 h-5 w-5 text-orange-400" />
            <h2 className="font-semibold">Keep radio on</h2>
            <p className="mt-1 text-sm text-zinc-500">
              Agents must loop <code className="text-zinc-300">wait_for_messages</code>{" "}
              or run <code className="text-zinc-300">opengateway listen</code> — otherwise
              they show as joined, not listening.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
